import { render, staticRenderFns } from "./TitleIcon.vue?vue&type=template&id=4ab49bd8&"
import script from "./TitleIcon.ts?vue&type=script&lang=ts&"
export * from "./TitleIcon.ts?vue&type=script&lang=ts&"
import style0 from "./TitleIcon.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports